import React from 'react';
import { TabsItem } from 'components/Tabs';
import Flex, { Grid } from 'components/Flex';
import IInvolved from 'interfaces/involved';

import { UserIcon } from '../../../../styles/icons';
import { formatCpf, formatDate } from '../../../../utils';
import { WrapperName, LineTitle, WrapperTitle } from './styles';

interface InvolvedData {
  detailInvolved: IInvolved[];
}

const InvolvedsDetail: React.FC<InvolvedData> = ({ detailInvolved }) => {
  const involveds = detailInvolved;

  return (
    <TabsItem title="Envolvidos">
      <Grid container justify="flex-start" spacing={1}>
        {involveds?.map((involved) => (
          <Grid item key={involved.id} xs={12} sm={12} md={12}>
            <LineTitle>
              <Grid container spacing={1}>
                <WrapperName>
                  <UserIcon />&nbsp;{involved.name}
                </WrapperName>
                <Flex title="Algemas" xs={12} sm={6} md={4}>
                  {involved.handcuffs}
                </Flex>
                <Flex title="Envolvimento" xs={12} sm={6} md={4}>
                  {involved.type_involvement.toUpperCase()}
                </Flex>
                <Flex title="CPF" xs={12} sm={6} md={4}>
                  {formatCpf(involved.document)}
                </Flex>
                <Flex title="RG" xs={12} sm={6} md={4}>
                  {involved.document_secondary}
                </Flex>
                <Flex title="Data de Nascimento" xs={12} sm={6} md={4} textAutoSize>
                  {formatDate(involved.birthday)}
                </Flex>
                <Flex title="Estado civil" xs={12} sm={6} md={4}>
                  {involved.marital}
                </Flex>
                <Flex title="Mãe" xs={12} sm={6} md={6}>
                  {involved.mather}
                </Flex>
                <Flex title="Pai" xs={12} sm={6} md={6}>
                  {involved.father}
                </Flex>
                <WrapperTitle>Logradouro:</WrapperTitle>
                <Flex title="Endereço" xs={12} sm={6} md={4}>
                  {involved.street}
                </Flex>
                <Flex title="Número" xs={12} sm={6} md={4}>
                  {involved.number}
                </Flex>
                <Flex title="Complemento" xs={12} sm={6} md={4}>
                  {involved.complement}
                </Flex>
                <Flex title="Bairro" xs={12} sm={6} md={4}>
                  {involved.neighborhood}
                </Flex>
                <Flex title="Município" xs={12} sm={6} md={4}>
                  {involved.city}
                </Flex>
                <Flex title="Estado" xs={12} sm={6} md={4}>
                  {involved.state}
                </Flex>
              </Grid>
            </LineTitle>
          </Grid>
        ))}
      </Grid>
    </TabsItem>
  );
};

export default InvolvedsDetail;
